module.exports = __webpack_public_path__ + "static/img/logo_29.6ccdb7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_29.png
// module id = HK4l
// module chunks = 1